const services = [
  {
    icon: 'ri-code-s-slash-line',
    title: 'ITエンジニア紹介',
    description:
      '経験豊富なITエンジニアを、貴社のプロジェクトに最適なスキルセットを持つ人材を迅速に選定・紹介します。規模や期間に関わらず、あらゆる開発ニーズに対応いたします。',
  },
  {
    icon: 'ri-calculator-line',
    title: '経理スペシャリスト紹介',
    description:
      '経験豊富な経理スペシャリストを、貴社の業務内容や規模に合わせて紹介いたします。経理業務の効率化、コスト削減、そして精度の向上に貢献いたします。',
  },
  {
    icon: 'ri-twitter-x-line',
    title: 'SNSアカウントマッチング支援',
    description:
      'ターゲットとなるユーザー層に特化したSNSアカウントを、貴社のニーズに合わせてマッチングします。新たな顧客獲得やブランド認知度向上を支援いたします。',
  },
  {
    icon: 'ri-building-2-line',
    title: '事業譲渡希望オーナーの紹介',
    description:
      '事業譲渡を検討されているオーナー様を、貴社の希望条件に基づいて紹介いたします。スムーズな事業承継やその仲介業務をサポートいたします。',
  },
];

const ServicesSection = () => {
  return (
    <section id="services" className="py-20 bg-[#f7f9f7]">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[#3d6b4f] text-xs font-semibold tracking-widest uppercase mb-3">Services</p>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">マッチング支援サービス</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className="bg-white rounded-lg p-6 border border-gray-100 hover:border-[#3d6b4f]/30 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-[#3d6b4f]/10 rounded-md mb-4">
                <i className={`${service.icon} text-[#3d6b4f] text-lg`}></i>
              </div>
              <h3 className="text-sm font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-xs text-gray-500 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
